import { reactive } from "@vue/composition-api"

interface ObserverExchangeBus {
    intersected: boolean
}

const observerExchangeBus: ObserverExchangeBus = reactive<ObserverExchangeBus>({
    intersected: false
})

export function ObserverExchangeBus(): ObserverExchangeBus {
    return observerExchangeBus
}